import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getAiVisCssVars } from './ai-vis/aivisTheme';
import './ai-vis/ai-vis.css';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div style={{ ...getAiVisCssVars(), minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: 'var(--aivis-bg, #f5f6fa)', padding: '2rem', textAlign: 'center' }}>
      <div style={{ maxWidth: 480, width: '100%' }}>
        {/* Big 404 number */}
        <div style={{ fontSize: 96, fontWeight: 800, lineHeight: 1, color: 'var(--aivis-accent, #6C63FF)', letterSpacing: '-4px', userSelect: 'none' }}>
          404
        </div>

        <h1 style={{ fontSize: 24, fontWeight: 700, margin: '16px 0 8px', color: 'var(--aivis-text, #1a1a2e)' }}>
          Page not found
        </h1>
        <p style={{ fontSize: 15, color: 'var(--aivis-text-muted, #6b7280)', margin: '0 0 32px', lineHeight: 1.6 }}>
          The page you're looking for doesn't exist or may have been moved.
        </p>

        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => navigate(-1)}
            className="aivis-btn-secondary"
            style={{ minWidth: 120 }}
          >
            ← Go back
          </button>
          <Link to="/ai-vis/home" className="aivis-btn-primary" style={{ minWidth: 140, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
            Go to dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
